module.exports = __webpack_public_path__ + "static/img/0004.68e379f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/0004.png
// module id = YYoF
// module chunks = 1